import { cn } from '@editor/utils/cn'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { CSSProperties } from 'react'

export interface FaIconProps {
  icon: IconDefinition
  className?: string
  style?: CSSProperties
}

export function FaIcon({ icon, className, style }: FaIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      viewBox={`0 0 ${icon.icon[0]} ${icon.icon[1]}`}
      aria-hidden
      focusable={false}
      className={cn(
        'inline-block h-[1em] overflow-visible align-[-0.125em]',
        className
      )}
      style={style}
    >
      <path
        fill="currentColor"
        d={Array.isArray(icon.icon[4]) ? icon.icon[4][0] : icon.icon[4]}
      ></path>
    </svg>
  )
}
